import { startOfMinute, startOfDay } from 'date-fns';
import { add } from 'date-arithmetic';
import { a as diff } from '../../dates-492a56eb.js';

const getDstOffset = (start, end) => start.getTimezoneOffset() - end.getTimezoneOffset();
const getKey = (min, max, timeStep, timeSlotCount) => `${+startOfMinute(min)}` + `${+startOfMinute(max)}` + `${timeStep}-${timeSlotCount}`;
function getTimeSlots({
  min: start,
  max: end,
  timeStep
}) {
  const timeSlotCount = 60 / timeStep;
  const key = getKey(start, end, timeStep, timeSlotCount);
  const dayStart = startOfDay(start);
  const dayStartDstOffset = getDstOffset(dayStart, start);
  const totalMinutes = 1 + diff(start, end, 'minutes') + getDstOffset(start, end);
  const minutesFromMidnight = diff(dayStart, start, 'minutes') + dayStartDstOffset;
  const numGroups = Math.ceil(totalMinutes / (timeStep * timeSlotCount));
  const numSlots = numGroups * timeSlotCount;
  const groups = Array(numGroups);
  const timeSlots = Array(numSlots);
  for (let group = 0; group < numGroups; group++) {
    groups[group] = Array(timeSlotCount);
    for (let slot = 0; slot < timeSlotCount; slot++) {
      const slotIndex = group * timeSlotCount + slot;
      const minFromStart = slotIndex * timeStep;
      // eslint-disable-next-line no-multi-assign
      timeSlots[slotIndex] = groups[group][slot] = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, minutesFromMidnight + minFromStart, 0, 0);
    }
  }
  const lastSlotMinFromStart = timeSlots.length * timeStep;
  timeSlots.push(new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, minutesFromMidnight + lastSlotMinFromStart, 0, 0));
  function positionFromDate(date) {
    const diff$1 = diff(start, date, 'minutes') + getDstOffset(start, date);
    return Math.min(diff$1, totalMinutes);
  }
  return {
    timeStep,
    timeSlotCount,
    groups,
    update(args) {
      // @ts-ignore
      if (getKey(args) !== key) return getTimeSlots(args);
      return this;
    },
    nextTimeSlot(timeSlot) {
      let next = timeSlots[Math.min(timeSlots.indexOf(timeSlot) + 1, timeSlots.length - 1)];
      if (next === timeSlot) next = add(timeSlot, timeStep, 'minutes');
      return next;
    },
    closestTimeSlotToPosition(percent) {
      const timeSlot = Math.min(timeSlots.length - 1, Math.max(0, Math.floor(percent * numSlots)));
      return timeSlots[timeSlot];
    },
    closestTimeSlotFromPoint(point, boundaryRect) {
      const range = Math.abs(boundaryRect.top - boundaryRect.bottom);
      return this.closestTimeSlotToPosition((point.y - boundaryRect.top) / range);
    },
    getRange(rangeStart, rangeEnd) {
      const rangeStartMin = positionFromDate(rangeStart);
      const rangeEndMin = positionFromDate(rangeEnd);
      const top = rangeEndMin - rangeStartMin < timeStep ? (rangeStartMin - timeStep) / (timeStep * numSlots) * 100 : rangeStartMin / (timeStep * numSlots) * 100;
      return {
        top,
        height: rangeEndMin / (timeStep * numSlots) * 100 - top,
        start: positionFromDate(rangeStart),
        startDate: rangeStart,
        end: positionFromDate(rangeEnd),
        endDate: rangeEnd
      };
    }
  };
}

export { getTimeSlots };
